import classNames from 'classnames';
import { Gamepad2 } from 'lucide-react';
import React from 'react';

interface SmallButtonProps {
  label?: string | React.ReactNode;
  onClick: () => void | Promise<void>;
  disabled?: boolean;
  className?: string;
  children?: React.ReactNode;
  iconAfter?: React.ReactNode;
}

const SmallButton: React.FC<SmallButtonProps> = ({
  label,
  onClick,
  disabled = false,
  className,
  children,
  iconAfter,
}) => (
  <button
    type="button"
    disabled={disabled}
    onClick={() => void onClick()}
    className={classNames(
      'inline-flex items-center justify-center gap-1 rounded-lg bg-slate-100 py-1.5 pr-2 pl-2.5 font-manrope text-sm font-medium text-slate-900 transition hover:bg-blue-50 disabled:cursor-not-allowed disabled:text-slate-400',
      className
    )}
  >
    <span>{label ?? children}</span>
    {iconAfter ?? <Gamepad2 className="h-4 w-4 text-[#3f54a4]" />}
  </button>
);

export default SmallButton;
